/* Defers standalone hosted videos that do not use the theme's shared video-media component. */
if (!customElements.get('bastion-lazy-video')) {
  customElements.define(
    'bastion-lazy-video',
    class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');

        if (!this.video) return;

        this.video.preload = 'none';

        if (!this.hasAttribute('autoplay')) return;

        const playVideo = () => {
          this.video.preload = 'metadata';
          this.video.play().catch(() => {});
        };

        if (!('IntersectionObserver' in window)) {
          playVideo();
          return;
        }

        this.observer = new IntersectionObserver((entries) => {
          const isNearViewport = entries.some((entry) => entry.isIntersecting);

          if (isNearViewport) {
            playVideo();
          } else {
            this.video.pause();
          }
        }, { rootMargin: '200px 0px' });

        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }
  );
}

/* Product-card secondary images are useful only on devices with a real hover pointer. */
(() => {
  const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

  const loadHoverImages = (root = document) => {
    if (!hoverQuery.matches) return;

    const images = [];

    if (root instanceof Element && root.matches('[data-bastion-hover-image]')) {
      images.push(root);
    }

    images.push(...root.querySelectorAll('[data-bastion-hover-image]'));

    images.forEach((image) => {
      if (image.dataset.srcset) image.srcset = image.dataset.srcset;
      if (image.dataset.src) image.src = image.dataset.src;

      image.removeAttribute('data-srcset');
      image.removeAttribute('data-src');
      image.removeAttribute('data-bastion-hover-image');
    });
  };

  const initialize = () => loadHoverImages();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  hoverQuery.addEventListener?.('change', initialize);
  document.addEventListener('shopify:section:load', (event) => loadHoverImages(event.target));
  document.addEventListener('theme:loading:end', initialize);
})();
